module.exports = __webpack_public_path__ + "img/KSC00793.57d54ab9.jpg";